export const Footer = () => {
  return (
    <div className="footer">
      Development by <a href="https://www.linkedin.com/in/inessa-kukushkina-48130ab9/" target="_blank" rel="noreferrer">Inessa Kukushkina</a>
    </div>
  )
}